import BaseAuthDriver from "./BaseAuthDriver";

const defaultUserData = {
  username: "admin",
  name: "admin",
  type: "superadmin"
};

class NoAuthDriver extends BaseAuthDriver {
  static init() {
    return new NoAuthDriver();
  }

  getCurrentUser() {
    return new Promise((resolve, reject) => {
      resolve(defaultUserData);
    });
  }

  isCurrentUserAuthorizedTo(action) {
    return new Promise((resolve, reject) => {
      if (this.isLoggedIn()) {
        resolve(true);
      } else {
        reject("User is not authorized");
      }
    });
  }

  isUserLoggedIn() {
    return new Promise((resolve, reject) => {
      this.getCurrentUser()
        .then((userData) => {
          resolve(!!userData);
        })
        .catch((error) => {
          console.debug(error);
          resolve(false);
        });
    });
  }

  attemptLogin(creds) {
    return new Promise((resolve, reject) => {
      resolve({ user: defaultUserData });
    });
  }
}

export default NoAuthDriver;
